export const ACLS = {
	OFFSETS: {
		CREATE: 'offsets:create',
		READ: 'offsets:read',
		LIST: 'offsets:list',
		UPDATE: 'offsets:update',
		DELETE: 'offsets:delete',
	},
	USERS: {
		CREATE: 'users:create',
		READ: 'users:read',
		LIST: 'users:list',
		UPDATE: 'users:update',
		DELETE: 'users:delete',
		ACTIVATE: 'users:activate',
		FORGOT_PASSWORD: 'users:forgot_password',
		UPDATE_PASSWORD: 'users:update_password',
		UPDATE_EMAIL: 'users:update_email',
		RESET_EMAIL: 'users:reset_email',
		DISABLE: 'users:disable',
		ENABLE: 'users:enable',
	},
	ORGANIZATIONS: {
		CREATE: 'organizations:create',
		READ: 'organizations:read',
		LIST: 'organizations:list',
		UPDATE: 'organizations:update',
		DELETE: 'organizations:delete',
	},
	API_TOKENS: {
		CREATE: 'api_tokens:create',
		READ: 'api_tokens:read',
		LIST: 'api_tokens:list',
		UPDATE: 'api_tokens:update',
		DELETE: 'api_tokens:delete',
	},
	MINT_HISTORIES: {
		CREATE: 'aco2_tokens:create',
		READ: 'aco2_tokens:read',
		LIST: 'aco2_tokens:list',
		UPDATE: 'aco2_tokens:update',
	},
	IMPORT_HISTORIES: {
		CREATE: 'import_histories:create',
		READ: 'import_histories:read',
		LIST: 'import_histories:list',
		UPDATE: 'import_histories:update',
	},
	ENTITIES: {
		READ: 'entities:read',
		LIST: 'entities:list',
		CREATE: '',
		UPDATE: '',
		DELETE: '',
	},
	BRANDS: {
		CREATE: 'brands:create',
		READ: 'brands:read',
		LIST: 'brands:list',
		UPDATE: 'brands:update',
		DELETE: 'brands:delete',
		VERIFY: 'brands:verify',
		UNVERIFY: 'brands:unverify',
	},
	PRODUCERS: {
		CREATE: 'producers:create',
		READ: 'producers:read',
		LIST: 'producers:list',
		UPDATE: 'producers:update',
		DELETE: 'producers:delete',
		VERIFY: 'producers:verify',
		UNVERIFY: 'producers:unverify',
	},
	ROLES: {
		CREATE: 'roles:create',
		READ: 'roles:read',
		LIST: 'roles:list',
		UPDATE: 'roles:update',
		DELETE: 'roles:delete',
	},
	PROJECTS: {
		READ: 'projects:read',
		LIST: 'projects:list',
		LIST_PARENT_ORGANIZATIONS:
			'projects:listParentOrganizations',
		LIST_PARENT_PRODUCERS: 'projects:listParentProducers',
		CREATE: '',
		UPDATE: '',
		DELETE: '',
	},
	MEASURABILITIES: {
		CREATE: 'measurabilities:create',
		READ: 'measurabilities:read',
		LIST: 'measurabilities:list',
		LIST_PARENT_ORGANIZATIONS:
			'measurabilities:listParentOrganizations',
		LIST_PARENT_PRODUCERS:
			'measurabilities:listParentProducers',
		UPDATE: 'measurabilities:update',
		DELETE: 'measurabilities:delete',
		ACTIVATE: 'measurabilities:activate',
		SYNC_QUANTITY: 'measurabilities:syncQuantity',
	},
	ADDITIONALITIES: {
		CREATE: 'additionalities:create',
		READ: 'additionalities:read',
		LIST: 'additionalities:list',
		LIST_PARENT_ORGANIZATIONS:
			'additionalities:listParentOrganizations',
		LIST_PARENT_PRODUCERS:
			'additionalities:listParentProducers',
		UPDATE: 'additionalities:update',
		DELETE: 'additionalities:delete',
		ACTIVATE: 'additionalities:activate',
		SYNC_FINANCING: 'additionalities:syncFinancing',
	},
	SITES: {
		CREATE: 'sites:create',
		READ: 'sites:read',
		LIST: 'sites:list',
		UPDATE: 'sites:update',
		DELETE: 'sites:delete',
	},
	METER_POINTS: {
		CREATE: 'meter_points:create',
		READ: 'meter_points:read',
		LIST: 'meter_points:list',
		UPDATE: 'meter_points:update',
		DELETE: 'meter_points:delete',
	},
	PRODUCTIONS: {
		CREATE: 'productions:create',
		READ: 'productions:read',
		LIST: 'productions:list',
		DELETE: 'productions:delete',
		DELETE_MULTIPLE: 'productions:deleteMultiple',
		VERIFY: 'productions:verify',
		UNVERIFY: 'productions:unverify',
		ADMIN: 'productions:admin',
	},
	CONVERSION_FACTORS: {
		CREATE: 'conversion_factors:create',
		READ: 'conversion_factors:read',
		LIST: 'conversion_factors:list',
		DELETE: 'conversion_factors:delete',
		UPDATE: '',
	},
	PUBLIC_ORGANIZATIONS: {
		READ: 'public_organizations:read',
		LIST: 'public_organizations:list',
	},
	PUBLIC_ENTITIES: {
		READ: 'public_entities:read',
		LIST: 'public_entities:list',
	},
	PUBLIC_PROJECTS: {
		READ: 'public_projects:read',
		LIST: 'public_projects:list',
	},
	PUBLIC_MEASURABILITIES: {
		READ: 'public_measurabilities:read',
		LIST: 'public_measurabilities:list',
	},
	PUBLIC_ADDITIONALITIES: {
		READ: 'public_measurabilities:read',
		LIST: 'public_measurabilities:list',
	},
};
